/**
 * @format
 */
import React from 'react';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import { Image } from 'react-native-elements';

interface Props {
  size: number;
}

const Logo: React.FC<Props> = ({ size }) => {
  return (
    <View style={styles.container}>
      <Image
        source={require('../../assets/zonetail_512.png')}
        style={[styles.logo, { width: size, height: size }]}
        PlaceholderContent={<ActivityIndicator />}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    resizeMode: 'cover',
  },
});

export default Logo;
